import React, { useEffect } from "react";
import { useTranslation, Trans} from "react-i18next";
import self_wash_laundry from "../assets/images/self_wash_laundry3.png";
import basket from "../assets/images/basket.png";
import guarantee from "../assets/images/guarantee.png";
import basket_white from "../assets/images/basket_white.png";
import guarantee_white from "../assets/images/guarantee_white.png";
import {triggerFadeInOnScroll2} from "../assets/js/swithalert";
import config from "../config";
import Breadcrumb from "../components/Breadcrumb";


function SelfWash() {

  const {t} = useTranslation();

  useEffect(() => {
    triggerFadeInOnScroll2();
  }, []);

  return (
    <div className="main">
        <div class="section_selfwash_laundry" data-aos="">
            <Breadcrumb />
            <div class="subtitle">
                <div class="rect col-sm-4 col-4 my-auto pt-sm-4 pt-4 fade-in2">
                    <span class="bar"></span>
                    <span class="bar"></span>
                    <span class="bar"></span>
                    <span class="bar"></span>
                </div>           
                <h2 class="fade-in2">{t("selfwash_laundry_title")}</h2>
            </div> 
            <div class="content">
                <p class="text-center py-4 fade-in2 p1">
                    <Trans i18nKey="selfwash_laundry_content_1" 
                        values={{ brand: config.brand, washer_brand: "Alliance Laundry Systems" }}>
                    </Trans>
                </p>
                <div class="row">
                    <div class="col-md-6 left text-start">
                        <p class="text-start p1">{t("selfwash_laundry_content_2")}</p>
                        <ul class="list list-icons list-icons-style-3">
                            <li class="row"><i class="fas fa-check col-2"> </i> <small class="col-10"><Trans i18nKey="selfwash_laundry_text_1"></Trans></small></li>
                            <li class="row"><i class="fas fa-check col-2"> </i> <small class="col-10"><Trans i18nKey="selfwash_laundry_text_2"></Trans></small></li>
                            <li class="row"><i class="fas fa-check col-2"> </i> <small class="col-10"><Trans i18nKey="selfwash_laundry_text_3"></Trans></small></li>
                        </ul>
                        <p class="text-start p2">{t("selfwash_laundry_text_4")}</p>
                    </div>
                    <div class="col-md-6 right text-start">
                        <img src={self_wash_laundry} style={{"max-width":"100%"}}/>
                    </div>
                </div>
                <div class="row">
                    <p class="text-center try_garentee">
                        <img src={basket} class="" style={{"max-width":"64px"}}/>
                        <Trans i18nKey="try_garentee_text"></Trans>
                        <img src={guarantee} class="pb-2" style={{"max-width":"51px", "padding-left":"6px"}}/>
                    </p>
                </div>
                
            </div>
        </div>
        <div class="section_selfwash_why" data-aos="">
            <div class="subtitle">
                <div class="rect col-sm-4 col-4 my-auto pt-sm-4 pt-4">
                <span class="bar"></span>
                <span class="bar"></span>
                <span class="bar"></span>
                <span class="bar"></span>
                </div>           
                <h2 class=""><Trans i18nKey="selfwash_why_title" values={{brand: config.brand}}></Trans></h2>
            </div> 
            <div class="content">
                <p class="text-center py-4">
                    <Trans i18nKey="selfwash_why_content" values={{brand: config.brand, big_geneva:"Grand Genève"}}></Trans>
                </p>
                <div class="row gy-5 g-sm-4 g-xl-5">
                    <div class="col-md-6 left text-start">
                        <div class="carding p-3 p-md-2 p-lg-3">
                            <h3 class="text-start"><Trans i18nKey="selfwash_why_left_subtitle_1" values={{brand: config.brand}}></Trans> </h3>
                            <h4 class="text-start mb-sm-4 mb-3">{t("selfwash_why_left_subtitle_2")}</h4>
                            <p><Trans i18nKey="selfwash_why_left_text_1"></Trans></p>
                            <ul class="list list-icons list-icons-style-3">
                                <li class="mb-2 row"><i class="fas fa-check col-2"> </i> <small class="col-10"><strong>{t("selfwash_why_left_text_2")}</strong></small></li>
                                <li class="mb-2 row"><i class="fas fa-check col-2"> </i> <small class="col-10"><strong>{t("selfwash_why_left_text_3")}</strong></small></li>
                                <li class="mb-2 row"><i class="fas fa-check col-2"> </i> <small class="col-10"><strong>{t("selfwash_why_left_text_4")}</strong></small></li>
                                <li class="mb-2 row"><i class="fas fa-check col-2"> </i> <small class="col-10"><strong>{t("selfwash_why_left_text_5")}</strong></small></li>
                            </ul>
                            <h4 class="mb-sm-4 mb-3">{t("selfwash_why_left_subtitle_3")}</h4>
                            <ul class="list list-icons list-icons-style-3">
                                <li class="row"><i class="fas fa-check col-2"> </i> <small class="col-10"><Trans i18nKey="selfwash_why_left_text_6"></Trans></small></li>
                                <li class="row"><i class="fas fa-check col-2"> </i> <small class="col-10"><Trans i18nKey="selfwash_why_left_text_7"></Trans></small></li>
                            </ul>
                            <h4 class="mb-sm-4 mb-1">{t("selfwash_why_left_subtitle_4")}</h4>

                            <p class="text-start">
                                <Trans i18nKey="selfwash_why_left_text_8" values={{brand: config.brand}}></Trans>
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 right text-start">
                        <div class="carding p-3 p-md-2 p-lg-3">
                            <h3 class="text-start"><Trans i18nKey="selfwash_why_right_subtitle_1" values={{brand: config.brand}}></Trans></h3>
                            <p><Trans i18nKey="selfwash_why_right_text_1"></Trans></p>
                            <h4 class="text-start mb-sm-4 mb-3">{t("selfwash_why_right_subtitle_2")}</h4>
                            <ul class="list list-icons list-icons-style-3">
                                <li class="mb-2 row"><i class="fas fa-check col-2"> </i> <small class="col-10"><Trans i18nKey="selfwash_why_right_text_2"></Trans></small></li>
                                <li class="mb-2 row"><i class="fas fa-check col-2"> </i> <small class="col-10"><Trans i18nKey="selfwash_why_right_text_3"></Trans></small></li>
                                <li class="mb-2 row"><i class="fas fa-check col-2"> </i> <small class="col-10"><Trans i18nKey="selfwash_why_right_text_4"></Trans></small></li>
                            </ul>
                            <h4 class="mb-sm-4 mb-3">{t("selfwash_why_right_subtitle_3")}</h4>
                            <ul class="list list-icons list-icons-style-3">
                                <li class="row"><i class="fas fa-check col-2"> </i> <small class="col-10"><Trans i18nKey="selfwash_why_right_text_5"></Trans></small></li>
                                <li class="row"><i class="fas fa-check col-2"> </i> <small class="col-10"><Trans i18nKey="selfwash_why_right_text_6"></Trans></small></li>
                            </ul>

                            <p class="text-start">
                                <Trans i18nKey="selfwash_why_right_text_7"></Trans>
                            </p>
                        </div>
                    </div>
                </div>
                    <div class="row mt-4">
                        
                        <p class="text-center try_garentee mb-0">
                            <img src={basket_white} class="" style={{"max-width":"64px"}}/>
                            <Trans i18nKey="try_garentee_text"></Trans>
                            <img src={guarantee_white} class="pb-2" style={{"max-width":"51px", "padding-left":"6px"}}/>
                        </p>
            
                    </div>
                
            </div>
        </div>
      
    </div>
  );
}

export default SelfWash;
